import { render, staticRenderFns } from "./p-choose-med-type.vue?vue&type=template&id=1f7bbc78&scoped=true"
import script from "./p-choose-med-type.vue?vue&type=script&lang=js"
export * from "./p-choose-med-type.vue?vue&type=script&lang=js"
import style0 from "./p-choose-med-type.vue?vue&type=style&index=0&id=1f7bbc78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7bbc78",
  null
  
)

export default component.exports